import React, { useEffect, useState } from "react";
import ct from "class-types.macro";
import { toError } from "@wss/error-tracking/utils";
import { logException } from "@wss/error-tracking";
import { Throwable } from "@wss/error-tracking/throwable";
import SingleProduct from "../shared/SingleProduct";
import DoubleProduct from "../shared/DoubleProduct";
import { User } from "~/common/Store/models/User";
import { BannerType } from "../shared/definitions";
import { QualityRatingItem } from "~/common/Store/models/QualityRating";
import DismissButton from "../shared/DismissButton";
import connectUserAndChat from "~/common/Store/connectUserAndChat";
interface Props {
  itemNumber: string;
  toggleSpotlightBanner: (enabled: boolean) => void;
  user: User;
  mounted: boolean;
}
const GoodBetterBest = ({
  itemNumber,
  toggleSpotlightBanner,
  user,
  mounted
}: Props) => {
  const [data, setData] = useState<QualityRatingItem[]>([]);
  useEffect(() => {
    const getQualityRatingItem = async (): Promise<Throwable> => {
      const endpointUrl = "/api/productlisting/qualityratinggroup/";
      try {
        const response = await fetch(`${endpointUrl}?itemNumber=${encodeURIComponent(itemNumber)}`);
        const qualityRatingItems = await response.json<QualityRatingItem[]>();
        if (qualityRatingItems && qualityRatingItems.length) {
          setData(qualityRatingItems);
        }
        return {
          isError: false
        };
      } catch (e) {
        const error = new Error("Error in getQualityRatingItem", {
          cause: toError(e)
        });
        await logException(error);
        setData([]);
        return {
          error,
          isError: true
        };
      }
    };
    getQualityRatingItem();
  }, [itemNumber]);
  const cn = ct("bg-white", "border-gray-200", "rounded", "border-solid", "border", "flex", "flex-col", "mt-3", "mb-3", "overflow-hidden", "relative", "lt:flex-row");
  return <>
      {mounted && data.length > 1 && <div id="spotlight-banner-GoodBetterBest" data-testid="spotlight-banner-GoodBetterBest" className={cn}>
          <DismissButton toggleSpotlightBanner={toggleSpotlightBanner} isGoodBetterBest />
          {data.length === 2 && data[1] && <SingleProduct originalLinkingItemNumber={itemNumber} item={data[1]} bannerType={BannerType.GoodBetterBest} user={user} />}
          {data.length === 3 && data[1] && data[2] && <DoubleProduct originalLinkingItemNumber={itemNumber} items={data.slice(1)} bannerType={BannerType.GoodBetterBest} user={user} />}
        </div>}
    </>;
};
export default connectUserAndChat(GoodBetterBest);